export default "__VITE_ASSET___TXVlcMm__"